import React from 'react';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../../../src/assets/styles/table_custom_style';

const FilteredSearchTable = ({
  filteredData,
  filteredLabels,
  count,
  groupBy,
  averageRates
}) => {
  const tableData = filteredData
    ? filteredData.map((data, index) => ({
        id: index,
        label:
          filteredLabels && filteredLabels[index]
            ? filteredLabels[index] === '' ||
              typeof filteredLabels[index] === 'object'
              ? '-'
              : filteredLabels[index]
            : '-',
        quantity: data,
        average:
          averageRates && averageRates?.[index]
            ? averageRates?.[index].toFixed?.(2)
            : '-',
        percentual: count ? parseInt((100 * data) / count) : 0
      }))
    : [];

  const columns = [
    {
      dataField: 'label',
      text:
        groupBy === 'channel'
          ? 'Canal'
          : groupBy === 'queue'
          ? 'Fila'
          : groupBy === 'rate'
          ? 'Nota'
          : groupBy === 'type_survey'
          ? 'Tipo de Pesquisa'
          : groupBy === 'name_survey'
          ? 'Nome de Pesquisa'
          : groupBy === 'user'
          ? 'Usuário'
          : 'Categoria',
      style: individual_column_style,
      headerStyle: individual_header_style,
      formatter: (cell) => cell || '-',
      sort: true
    },
    {
      dataField: groupBy === 'rate' ? 'quantity' : 'average',
      text: groupBy === 'rate' ? 'Quantidade' : 'Média',
      formatter: (cell) =>
        cell || cell === 0 ? (groupBy === 'rate' ? cell : cell) : '-',
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    },
    {
      dataField: 'percentual',
      text: 'Percentual',
      formatter: (cell) => `${cell || 0}%`,
      style: individual_column_style,
      headerStyle: individual_header_style,
      sort: true
    }
  ];

  return (
    <Card id="table-search">
      <CardHeader>
        <h6 className="surtitle">Visão Geral</h6>
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            {filteredData && filteredLabels && (
              <ToolkitProvider keyField="id" data={tableData} columns={columns}>
                {(props) => (
                  <div className="py-1 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default FilteredSearchTable;
